import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { CompanyContractsParams, ContractsParams } from "@/api/types"

export function contractsOptions(params: ContractsParams = {}) {
	return queryOptions({
		queryKey: ["companies", "contracts", params],
		queryFn: () =>
			GET("/api/v1/companies/contracts", { params: { query: params } }),
	})
}

export function useContracts(params: ContractsParams = {}) {
	return useQuery(contractsOptions(params))
}

export function companyContractsOptions(
	companyId: number,
	params: CompanyContractsParams = {},
) {
	return queryOptions({
		queryKey: ["companies", companyId, "contracts", params],
		queryFn: () =>
			GET("/api/v1/companies/{company_id}/contracts", {
				params: {
					path: { company_id: companyId },
					query: params,
				},
			}),
		placeholderData: keepPreviousData,
		enabled: companyId > 0,
	})
}

export function useCompanyContracts(
	companyId: number,
	params: CompanyContractsParams = {},
) {
	return useQuery(companyContractsOptions(companyId, params))
}
